/**
 * Ámbito global compartido (UX01) · zona comercial + año + DG.
 * Un ÚNICO contexto que gobierna el selector de cabecera, el Cockpit, el
 * Copiloto y los destinos de detalle, para que todo mire la misma población.
 * Persistido en localStorage. '' = sin filtro (todas/os).
 */
import React, { createContext, useContext, useState, useCallback } from "react";

const ZonaContext = createContext(null);
const KEY = "valoriza_zona_global";
const KEY_Y = "valoriza_year_global";
const KEY_DG = "valoriza_dg_global";

const read = (k) => { try { return localStorage.getItem(k) || ""; } catch { return ""; } };
const write = (k, v) => { try { v ? localStorage.setItem(k, v) : localStorage.removeItem(k); } catch {} };

export function ZonaProvider({ children }) {
  const [zonaGlobal, setZona] = useState(() => read(KEY));
  const [yearGlobal, setYear] = useState(() => read(KEY_Y));
  const [dgGlobal, setDg] = useState(() => read(KEY_DG));

  const setZonaGlobal = useCallback((z) => { setZona(z || ""); write(KEY, z); }, []);
  const setYearGlobal = useCallback((y) => { setYear(y || ""); write(KEY_Y, y); }, []);
  const setDgGlobal = useCallback((d) => { setDg(d || ""); write(KEY_DG, d); }, []);

  return (
    <ZonaContext.Provider value={{ zonaGlobal, setZonaGlobal, yearGlobal, setYearGlobal, dgGlobal, setDgGlobal }}>
      {children}
    </ZonaContext.Provider>
  );
}

export function useZona() {
  return useContext(ZonaContext) || {
    zonaGlobal: "", setZonaGlobal: () => {},
    yearGlobal: "", setYearGlobal: () => {},
    dgGlobal: "", setDgGlobal: () => {},
  };
}
